import { Mutation, MutationTree } from "vuex";
import { SideBarMutation, SideBarState } from "@/components/sidebar/types";
import { AppMenuItem } from "@/services/apiService/api.types";

export const mutations: MutationTree<SideBarState> &
  Record<SideBarMutation, Mutation<SideBarState>> = {
  [SideBarMutation.SetSideBarOpen](state, sideBarOpen: boolean) {
    state.sideBarOpen = sideBarOpen;
  },
  [SideBarMutation.SetAppMenuItems](state, appMenuItems: AppMenuItem[]) {
    state.appMenuItems = appMenuItems;
  }
};
